export default {
  modals: [],
}
